import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/functions/analytics";
import { isNoAnalyticsRoute } from "../utils/analytics/analyticsRoutes";

export function usePageViewTracking(): void {
  const location = useLocation();
  const prevPathname = useRef(location.pathname);

  useEffect(() => {
    if (location.pathname !== prevPathname.current) {
      // The external approval/proof routes carry approval keys in the URL
      // (?code=, ?keys=, ?token= and /public/order/entry/:entryKey in the
      // path): no page_view at all is sent to GA4 there. Deliberately not
      // behind a flag (design section 8.1, exception 2).
      if (!isNoAnalyticsRoute(location.pathname)) {
        trackPageView(location.pathname + location.search);
      }
      prevPathname.current = location.pathname;
    }
  }, [location]);
}
